import React, { Component } from "react";
import Progress from "../common/Progress";
import TimeInput from "../common/Time-input";
import Input from "../common/Input";
import { Redirect } from "react-router-dom";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";

const mapStateToProps = (state) => ({
  business: state.business,
  headers: state.headers(),
  businessCatergories: state.businessCatergories,
  locations: state.locations,
  countries: state.countries,
  postOptions: state.postOptions,
  opening_hours : state.opening_hours,
  closing_hours : state.closing_hours,
  token: state.token,

});

export default connect(mapStateToProps)(
  class OpeningHours extends Component {
    state = {
      active_form: 1,
      cities: [],
      errors: {},
      openHours: {},
      timeModalIsOpen: false,
    };
    addTime = (ev) => {
      ev.preventDefault();
    };
    close_open = (ev) => {
      this.setState({ timeModalIsOpen: !this.state.timeModalIsOpen });
    };




    save = (ev) => {
      ev.preventDefault();
      
      // const formButton = ev.currentTarget.querySelector("button[type=submit]");
      // formButton.classList.add("loading");

      //clear errors
      this.setState({ loading: true, errors: {} });

      const form = ev.currentTarget;
      const formData = {
     
        opening_hours: [],
      };

      //rebuild opening hours...
      Object.keys(this.state.openHours).forEach((key) => {
        if (this.state.openHours[key] !== false)
          this.state.openHours[key].forEach((hour) => {
            formData.opening_hours.push({
              week_day: key[0].toLocaleUpperCase() + key.slice(1),
              opening_time: hour.from=="00:00"?"09:00": hour.from,
              closing_time: hour.to=="00:00"?"17:00": hour.to,
            });
          });
      });


        API({
          method: "PUT",
          url: "business/opening_hours",
          headers: { ...this.props.headers, Accept: "*/*" },
          data: formData,
        })
          .then(
            ({ data }) => {
              if (data.success) {
                this.setState({
                  redirect: `/onboarding/service/settings/${data.data.username}`,
                });

              }
            },
            ({ response }) => {
              if (response.data?.errors) {
                response.data.errors.map((error) =>
                  this.setState({
                    errors: {
                      ...this.state.errors,
                      [error.field]: error.message,
                    },
                  })
                );
              }
            }
          )
          .finally(() => {
            this.setState({ loading: false });
          });

    };
    rebuildOpeningBuildHours = () => {
       
      let result = [];
      Object.keys(this.state.openHours).map((key) => {
        if (this.state.openHours[key] !== false)
          this.state.openHours[key].map((hour) => {
            result.push({
              week_day: key,
              opening_time: hour.from,
              closing_time: hour.to,
            });
          });
      });
      return result;
    };
    setCities = (city) => {
      if (this.props.locations)
        this.props.locations.map(({ name, cities }) => {
          if (name.toLowerCase() == city.toLowerCase()) {
            this.setState({ cities });
          }
        });
    };
    openHours = () => {
      return Object.keys(this.state.openHours).map((key) =>
        this.state.openHours[key] !== false ? (
          <div className="input-grid-rapper" >
            <p className="label">{key}</p>
            {this.state.openHours[key].map((hour) => (
              <div class="input-grid" style={{ pointerEvents: "none" }}>
                <Input type="text" placeholder="00:00" value={hour.from} />
                <span class="seperator">-</span>
                <Input type="text" placeholder="00:00" value={hour.to} />
              </div>
            ))}
          </div>
        ) : (
          ""
        )
      );
    };
    setOpeningHours = () => {
      let opening_hours_state = {};
      const opening_hours = this.props.business.opening_hours;
      if (opening_hours)
        opening_hours.map((e) => {
          if (!opening_hours_state[e.week_day])
            opening_hours_state[e.week_day] = [];
          opening_hours_state[e.week_day].push({
            from: e.opening_time,
            to: e.closing_time,
          });
        });
      //  
      this.hasSetOpenHours = true;
      this.setState({ openHours: opening_hours_state });
    };
    updateHours = (hoursState) => {
      //  
      this.setState({
        openHours: { ...this.state.openHours, ...hoursState },
      });
       
    };
    render() {

      if (!this.hasSetOpenHours && this.props.business.id) {
        this.setOpeningHours();
      }
      return (

        <div className="onboarding-page">
      {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

          {/* <h1 className="form-title dsk flex center">Opening hours</h1> */}

          <Progress total={5} current={3}>
            <h1 className="form-title dsk">Opening hours </h1>
          </Progress>

          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">
              {/* <BackArrow /> */}
              Opening Hours
            </h1>
            <div className="form-container card">
              <form
                onSubmit={this.save}
                className="restrict"
                style={{marginTop:'-20px'}}
                encType="multipart/form-data"
              >
             <div>
                  <TimeInput
                  label="Monday"
                  defaultstate="opened"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Tuesday"
                  defaultstate="opened"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Wednesday"
                  defaultstate="opened"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Thursday"
                  defaultstate="opened"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Friday"
                  defaultstate="opened"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Saturday"
                  defaultstate="opened"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
                <TimeInput
                  label="Sunday"
                  defaultstate="closed"
                  updateHours={this.updateHours}
                  openHours={this.state.openHours}
                />
<br></br>
                  <div className="flex center space-btw">
                    <button
                      className={`default ${
                        this.state.loading ? "loading" : ""
                      }`}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      );
    }
  }
);
